function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M105.737 5.05682V0L78.3683 0L67.421 10.1136L101.631 10.1136L105.737 5.05682Z",
  fill: "#E9E9E9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M111.21 0.999999C111.21 0.447714 110.763 0 110.21 0L105.737 0V5.05682H110.21C110.763 5.05682 111.21 4.6091 111.21 4.05682V0.999999Z",
  fill: "#41AEFE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M105.737 5.05688L100.263 10.1137L110.382 18.4297C110.785 18.7616 111.363 18.3295 111.159 17.8483L105.737 5.05688Z",
  fill: "#41AEFE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2104 10.1135H96.1578V21.2385H85.2104V10.1135Z",
  fill: "#DEDEDE"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 75.6316,
  y: 20.2273,
  width: 30.1053,
  height: 68.7727,
  rx: 2,
  fill: "#E9E9E9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M75.6316 34.3865H105.737V70.7956H75.6316V34.3865Z",
  fill: "#B7DFFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9237 20.752H8.35851V30.379H16.9237V20.752Z",
  fill: "#005BA4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4182 31.5039C24.4182 30.3993 23.5228 29.5039 22.4182 29.5039H2.86392C1.75935 29.5039 0.863922 30.3993 0.863922 31.5039V89.0166H24.4182V31.5039Z",
  fill: "#B7DFFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4182 41.7563H0.863921V73.2631H24.4182V41.7563Z",
  fill: "#41AEFE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M41.2164 34.5945C41.2164 34.0422 40.7687 33.5945 40.2164 33.5945H30.5869C30.0346 33.5945 29.5869 34.0422 29.5869 34.5945V38.2498C29.5869 38.8021 30.0346 39.2498 30.5869 39.2498H40.2164C40.7687 39.2498 41.2164 38.8021 41.2164 38.2498V34.5945Z",
  fill: "#41AEFE"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 32.1195,
  height: 51.3885,
  rx: 2,
  transform: "matrix(-1 0 0 1 51.1844 37.6279)",
  fill: "#F4A710"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M54.1615 25.9546C54.1615 25.4023 54.6092 24.9546 55.1615 24.9546H68.0254C68.5777 24.9546 69.0254 25.4023 69.0254 25.9546V30.4898C69.0254 31.0421 68.5777 31.4898 68.0254 31.4898H55.1615C54.6092 31.4898 54.1615 31.0421 54.1615 30.4898V25.9546Z",
  fill: "#B7DFFF"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 41.421,
  y: 29.6155,
  width: 41.0526,
  height: 59.3844,
  rx: 2,
  fill: "#FED402"
});

function SvgClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 90,
    viewBox: "0 0 112 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.de7144f66336c9f2a7811168fd1f15e0.svg";
export { ForwardRef as ReactComponent };